// Anmeldung über Microsoft Entra im Browser (MSAL.js, Redirect-Flow).
//
// Client-ID und Tenant-ID werden zur Laufzeit von /api/config geholt, statt sie beim
// Bauen fest einzukompilieren. So gibt es genau EINEN Ort für die Konfiguration –
// die App-Einstellungen des Azure App Service – und dasselbe Build-Artefakt läuft in
// Test und Produktion.
import { PublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser';

let msalInstance = null;
let appConfig = null;

// Zwei Zwecke, zwei Token:
//  - unsere eigene API (Server prüft ihn und leitet daraus den Benutzer ab)
//  - Microsoft Graph (Outlook-Termine, direkt aus dem Browser abgefragt)
export const GRAPH_SCOPES = ['User.Read', 'Calendars.Read'];

export function apiScopes() {
  return [appConfig.apiScope];
}

export function getMsal() {
  if (!msalInstance) throw new Error('Anmeldung noch nicht initialisiert.');
  return msalInstance;
}

export async function initAuth() {
  const res = await fetch('/api/config');
  if (!res.ok) {
    throw new Error(
      'Server-Konfiguration nicht abrufbar. Läuft der API-Server und sind die ' +
        'Umgebungsvariablen gesetzt?'
    );
  }
  appConfig = await res.json();

  msalInstance = new PublicClientApplication({
    auth: {
      clientId: appConfig.clientId,
      authority: `https://login.microsoftonline.com/${appConfig.tenantId}`,
      redirectUri: window.location.origin,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      // sessionStorage: Anmeldung gilt für diesen Tab. Bewusst nicht localStorage,
      // damit auf geteilten Rechnern nichts hängen bleibt.
      cacheLocation: 'sessionStorage',
    },
  });

  await msalInstance.initialize();
  // Rückkehr von der Microsoft-Anmeldeseite verarbeiten
  await msalInstance.handleRedirectPromise();

  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) msalInstance.setActiveAccount(accounts[0]);

  return msalInstance;
}

export function login() {
  return getMsal().loginRedirect({ scopes: [...GRAPH_SCOPES, appConfig.apiScope] });
}

export function logout() {
  return getMsal().logoutRedirect({ postLogoutRedirectUri: window.location.origin });
}

// Holt still ein Token; nur wenn Microsoft eine Interaktion verlangt (z. B. weil die
// Zustimmung fehlt oder die Sitzung abgelaufen ist), öffnet sich ein Popup.
async function acquire(scopes) {
  const instance = getMsal();
  const account = instance.getActiveAccount() || instance.getAllAccounts()[0];
  if (!account) throw new Error('Nicht angemeldet.');

  try {
    const result = await instance.acquireTokenSilent({ scopes, account });
    return result.accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) {
      const result = await instance.acquireTokenPopup({ scopes, account });
      return result.accessToken;
    }
    throw err;
  }
}

export function getApiToken() {
  return acquire(apiScopes());
}

export function getGraphToken() {
  return acquire(GRAPH_SCOPES);
}
